type Props = {
  children: React.ReactNode;
  hideNavbar?: boolean;
};

const PageLayout = (props: Props): JSX.Element => {
  const { hideNavbar } = props;
  const url: string = window.location.pathname;
  return (
    <>
      {url === "/" ? (
        <></>
      ) : (
        <div style={{ height: !hideNavbar ? "45px" : 0, width: "100%" }}></div>
      )}
      {props.children}
    </>
  );
};

export default PageLayout;
